import { createAsyncThunk } from '@reduxjs/toolkit';
import createNotification from '../../../../utils/createNotification';
import { VDRFileSourceType } from '../models/vdr-file-source-type.enum';

export interface RenameVDRFileRequest {
    engagementId: number;
    fileSourceType: VDRFileSourceType;
    vdrFileId?: number;
    sourceAnswerFileId?: number;
    sourceDataTableCellFileId?: number;
    folderPath: string;
    newName: string;
}

const RENAME_VDR_FILE_FALLBACK_ERROR = 'An error occurred while renaming file.';

export const RenameVDRFile = createAsyncThunk(
    'dataRoom/renameFile',
    async (
        {
            engagementId,
            fileSourceType,
            vdrFileId,
            sourceAnswerFileId,
            sourceDataTableCellFileId,
            folderPath,
            newName,
        }: RenameVDRFileRequest,
        { getState }: any
    ) => {
        const axios = getState().core.axios;

        try {
            const response = await axios.put(
                `api/VirtualDataRoomDocument/${engagementId}/file/rename`,
                {
                    fileSourceType,
                    vdrFileId,
                    sourceAnswerFileId,
                    sourceDataTableCellFileId,
                    folderPath,
                    newName,
                }
            );

            if (response.status !== 200) {
                throw new Error(RENAME_VDR_FILE_FALLBACK_ERROR);
            }

            return response.data;
        } catch (error: any) {
            const serverMessage = error?.response?.data?.detail;
            if (!serverMessage) {
                createNotification(RENAME_VDR_FILE_FALLBACK_ERROR, 'error');
            }
            throw new Error(serverMessage || RENAME_VDR_FILE_FALLBACK_ERROR);
        }
    }
);
